import ptBr from './pt-br';

export default {
  locale: 'pt-br',
  messages: {
    'pt-br': ptBr,
  },
};
